/**
 * Checks if window is defined
 *
 * @returns {boolean} true if window is defined, false otherwise
 */ const isWindowDefined = typeof window !== 'undefined';
export default isWindowDefined;
